<script>
import { inventoryIssueService } from '../../../helpers/backend/inventory_issue.service'
/**
 * Transactions component
 */
export default {
  data() {
    return {
      data: [],
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      filter: null,
      filterOn: [],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        { key: "product_sku", sortable: true, label: "Product SKU" },
        { key: "product_name", sortable: true, label: "Product Name" },
        { key: "location", sortable: true, label: "Location" },
        { key: "type", sortable: true, label: "Issue Type" },
        { key: "quantity", sortable: true, label: "Quantity" },
        { key: "created_at", sortable: true, label: "Created At" },
        { key: "action" }
      ],
      showDismissibleAlert: false,
      active: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.data.length
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.data.length
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    setActive(b) {
      this.active = b
    },
    fetchData() {
      this.error = null
      this.loading = true
      this.showDismissibleAlert = false
      //const fetchedId = this.$route.params.id
      inventoryIssueService.getAll().then(
        data => {
          if (data.issues) {
            this.data = data.issues
          }
          this.loading = false
        },
        err => {
          this.error = "Failed to fetch inventory issue data. Error : " + err + "  Dissmiss to refresh"
          this.loading = false
          this.showDismissibleAlert = true
        }
      )
    },
    onDelete(id) {
      if (confirm("Do you really want to delete this instance, this action can't be undone?")) {
        inventoryIssueService.deleteById(id).then(
          () => {
            this.fetchData()
          },
          err => {
            this.error = "Failed to delete inventory issue. Error : " + err
            this.showDismissibleAlert = true
          }
        )
      }
    },
    onUpdate(id) {
      this.$emit('onEdit', id)
    }
  }
};
</script>

<template>
  <div v-if="this.active">
    <b-alert
      variant="danger"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="fetchData"
    >
      {{ error }}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Show&nbsp;
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select
                >&nbsp;entries
              </label>
            </div>
          </div>
          <!-- Search -->
          <div class="col-sm-12 col-md-6">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
            >
              <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input
                  v-model="filter"
                  type="search"
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
          <!-- End search -->
        </div>
        <div class="table-responsive">
          <b-table
            :items="data"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:cell(product_sku)="row">
              {{ row.item.inventory.product.sku }}
            </template>
            <template v-slot:cell(product_name)="row">
              {{ row.item.inventory.product.name }}
            </template>
            <template v-slot:cell(location)="row">
              {{
                row.item.inventory.location.machine_id.Valid
                  ? row.item.inventory.location.machine.serial_number
                  : ""
              }}
              {{
                row.item.inventory.location.warehouse_id.Valid
                  ? row.item.inventory.location.warehouse.name
                  : ""
              }}
              {{
                row.item.inventory.location.vehicle_id.Valid
                  ? row.item.inventory.location.vehicle.name +
                    "(" +
                    row.item.inventory.location.vehicle.vehicle_number +
                    ")"
                  : ""
              }}
              <div class="badge font-size-12 badge-soft-success">
                {{
                  row.item.inventory.location.machine_id.Valid ? "Machine" : ""
                }}
                {{
                  row.item.inventory.location.warehouse_id.Valid
                    ? "Warehouse"
                    : ""
                }}
                {{
                  row.item.inventory.location.vehicle_id.Valid ? "Vehicle" : ""
                }}
              </div>
            </template>
            <template v-slot:cell(type)="row">
              <div
                class="badge font-size-12 text-capitalize"
                :class="
                  row.value == 'discrepancy'
                    ? 'badge-soft-danger'
                    : 'badge-soft-warning'
                "
              >
                {{ row.value }}
              </div>
            </template>
            <template v-slot:cell(created_at)="row">
              {{ row.item.created_at.split("T")[0] }}
            </template>
            <template v-slot:cell(action)="row">
              <a
                @click="onUpdate(row.item.id)"
                class="mr-3 text-primary"
                v-b-tooltip.hover
                data-toggle="tooltip"
                title="Edit"
              >
                <i class="mdi mdi-pencil font-size-18"></i>
              </a>
              <a
                @click="onDelete(row.item.id)"
                class="text-danger"
                v-b-tooltip.hover
                title="Delete"
              >
                <i class="mdi mdi-trash-can font-size-18"></i>
              </a>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>